export const navLinks = [
  { label: 'Home', path: '/' },
  { label: 'Over ons', path: '/over-ons' },
  { label: 'Diensten', path: '/diensten' },
  { label: 'Vacatures', path: '/vacatures' },
  { label: 'Voor Kandidaten', path: '/voor-kandidaten' },
  { label: 'Voor Opdrachtgevers', path: '/voor-opdrachtgevers' },
  { label: 'Blog', path: '/blog' },
  { label: 'Contact', path: '/contact' },
];

export const heroData = {
  subtitle: 'Staffing Force',
  title: 'EXPERTS IN\nFINANCE & HR',
  description: 'Duurzaam detacheringsbureau uit Amsterdam. Het A-merk voor opdrachtgevers en kandidaten op het gebied van Finance & HR in Nederland.',
  videoUrl: 'https://customer-assets.emergentagent.com/job_staffforce-new-site/artifacts/gj3c0i7a_853789-hd_1920_1080_25fps.mp4',
  ctaPrimary: 'Bekijk vacatures',
  ctaSecondary: 'Neem contact op',
};

export const aboutData = {
  title: 'Over Staffing Force',
  subtitle: 'Duurzaam detacheren sinds 2007',
  description: 'Staffing Force is een duurzaam detacheringsbureau, opgericht in 2007, met jarenlange ervaring en expertise op het gebied van interim management, werving & selectie, en detavast constructies. Binnen deze vakgebieden richten wij ons op drie disciplines: Financieel, HR en Duurzaamheidsconsultants - van operationeel tot directieniveau binnen (internationale) organisaties.',
  mission: 'Het is onze missie om bij te dragen aan gelijke kansen op de werkvloer. Dit bereiken we door dagelijks verbeteringen door te voeren op het gebied van duurzaamheid, die in lijn zijn met onze visie: streven naar een wereld waar kansen op de werkvloer voor iedereen gelijk zijn.',
  highlight: 'Vanaf juni 2023 tot en met juni 2025 zijn wij met trots officieel B Corp-gecertificeerd geweest als eerste bureau in Nederland!',
  image: 'https://images.unsplash.com/photo-1521737711867-e3b97375f902?w=1600&q=85&auto=format&fit=crop',
};

export const servicesData = [
  {
    id: 1,
    title: 'Interim Management',
    description: 'Wij matchen ervaren interim managers met de juiste opdrachten. Van financieel directeur tot HR manager.',
    icon: 'Briefcase',
  },
  {
    id: 2,
    title: 'Werving & Selectie',
    description: 'Op zoek naar de perfecte kandidaat? Wij vinden het juiste talent voor uw organisatie.',
    icon: 'Search',
  },
  {
    id: 3,
    title: 'Detavast',
    description: 'Flexibel starten met de mogelijkheid tot vast dienstverband. De ideale oplossing voor beide partijen.',
    icon: 'Users',
  },
  {
    id: 4,
    title: 'Duurzaamheidsconsultants',
    description: 'Gespecialiseerde professionals die uw organisatie helpen met duurzaamheidsvraagstukken.',
    icon: 'Leaf',
  },
];

export const vakgebiedenData = [
  {
    id: 1,
    title: 'Finance',
    description: 'Van financial controller tot CFO - wij plaatsen de beste finance professionals.',
    image: 'https://images.unsplash.com/photo-1758518727820-28491c194bee?w=600&q=80',
    vacatures: 6,
  },
  {
    id: 2,
    title: 'HR',
    description: 'HR Business Partners, recruiters en payroll specialisten voor uw organisatie.',
    image: 'https://images.unsplash.com/photo-1765020553552-6286dde23660?w=600&q=80',
    vacatures: 3,
  },
  {
    id: 3,
    title: 'Duurzaamheid',
    description: 'Consultants die uw organisatie helpen met duurzaamheidsstrategie en implementatie.',
    image: 'https://images.unsplash.com/photo-1585871746932-e133d3fedf4d?w=600&q=80',
    vacatures: 1,
  },
  {
    id: 4,
    title: 'Interim Management',
    description: 'Ervaren interim managers die direct resultaat leveren op directieniveau.',
    image: 'https://images.unsplash.com/photo-1548964095-b9a292144866?w=600&q=80',
    vacatures: 4,
  },
];

export const timelineData = [
  {
    year: '2007',
    title: 'De oprichting',
    description: 'Staffing Force is van start gegaan in Hilversum. Opgericht door professionals uit de HR en Finance wereld die wisten dat detachering anders kan.',
  },
  {
    year: '2008',
    title: 'Snelle groei',
    description: 'Binnen een jaar groeide Staffing Force naar een organisatie met 40 betrokken professionals. De basis voor onze huidige klanten en preferred supplier contracten.',
  },
  {
    year: '2010',
    title: 'Verhuizing naar Amsterdam',
    description: 'De klassieke kantoorvilla in Hilversum werd ingeruild voor een modern, strak kantoor in Amsterdam. Passend bij ons merk: jong, vooruitstrevend en modern.',
  },
  {
    year: '2014',
    title: 'Nr. 2 ZZP Barometer',
    description: 'Staffing Force behaalde de 2e plek op de ZZP Barometer van Bemiddelaar van het Jaar! Een erkenning van onze kwaliteit en service.',
  },
  {
    year: '2018',
    title: 'Focus op duurzame detachering',
    description: 'Staffing Force maakt duurzame detachering tot kernwaarde: eerlijk, transparant en met oog voor mens en milieu.',
  },
  {
    year: '2023',
    title: 'B Corp gecertificeerd',
    description: 'Als eerste bureau in Nederland officieel B Corp-gecertificeerd! Een mijlpaal in onze missie voor duurzaam ondernemen en gelijke kansen.',
  },
];


export const vacaturesData = [
  {
    id: 1,
    title: 'Business Controller',
    location: 'Arnhem',
    type: 'Interim',
    discipline: 'Finance',
    level: 'Senior',
    reference: 'STJV02588',
    description: 'Een organisatie binnen de energieketen is op zoek naar een ervaren Business Controller die impact wil maken binnen een dynamische en veranderende omgeving. In deze rol werk je volledig in business partnerschap met operationele afdelingen.',
    date: '2026-04-13',
  },
  {
    id: 2,
    title: 'Financial Controller',
    location: 'Borne',
    type: 'Interim',
    discipline: 'Finance',
    level: 'Senior',
    reference: 'STJV02587',
    description: 'Voor een internationale en groeiende organisatie in de food safety en healthcare sector zijn wij op zoek naar een Financial Controller. In deze rol werk je aan betrouwbare financiële rapportages en draag je bij aan strategische besluitvorming.',
    date: '2026-04-13',
  },
  {
    id: 3,
    title: 'Junior en Senior Accountant',
    location: 'Didam',
    type: 'Vast',
    discipline: 'Finance',
    level: 'Senior',
    reference: 'STJV02585',
    description: 'Een modern accountants- en advieskantoor met een sterke groeiambitie is op zoek naar zowel een Junior/Medior Accountant als een Senior Accountant AA. In deze rol werk je mee aan het samenstellen en controleren van jaarrekeningen voor diverse MKB-klanten.',
    date: '2026-04-13',
  },
  {
    id: 4,
    title: 'Aangifte Medewerker',
    location: 'Didam',
    type: 'Vast',
    discipline: 'Finance',
    level: 'Medior',
    reference: 'STJV02584',
    description: 'Een modern accountants- en advieskantoor met een sterke groeiambitie is op zoek naar een nauwkeurige en gemotiveerde Aangiftemedewerker. In deze rol ben je verantwoordelijk voor het zelfstandig verzorgen van fiscale aangiften.',
    date: '2026-04-13',
  },
  {
    id: 5,
    title: 'Salarisadministrateur',
    location: 'Didam',
    type: 'Vast',
    discipline: 'Finance',
    level: 'Medior',
    reference: 'STJV02583',
    description: 'Een modern accountants- en advieskantoor met een gezonde groeiambitie is op zoek naar een nauwkeurige Salarisadministrateur die wil meegroeien binnen een full-service organisatie.',
    date: '2026-04-13',
  },
  {
    id: 6,
    title: 'Senior Adviseur',
    location: 'Utrecht',
    type: 'Interim',
    discipline: 'Finance',
    level: 'Senior',
    reference: 'STJV02550',
    description: 'Wil jij jouw financiële expertise inzetten om écht maatschappelijke impact te maken? In deze rol adviseer je overheden over de financiële en economische effecten van beleid en maatschappelijke vraagstukken.',
    date: '2026-04-10',
  },
  {
    id: 7,
    title: 'HR Adviseur',
    location: 'Zuid Beijerland',
    type: 'Vast',
    discipline: 'HR',
    level: 'Medior',
    reference: 'STJV02544',
    description: 'Ben jij die allround professional die met enthousiasme bijdraagt aan een veelzijdige functie, waarin je dagelijks schakelt tussen verschillende werkzaamheden en zo bijdraagt aan een soepel lopende HR-organisatie?',
    date: '2026-04-10',
  },
  {
    id: 8,
    title: 'Accountanting Specialist',
    location: 'Zaanstad',
    type: 'Interim',
    discipline: 'Finance',
    level: 'Medior',
    reference: 'STJV02577',
    description: 'Als Cost Accountant ben jij de financiële bril van productie en engineering. Je kijkt verder dan de cijfers en vertaalt kostprijsinformatie en projectdata naar inzichtelijke analyses.',
    date: '2026-04-06',
  },
  {
    id: 9,
    title: 'Hoofd Financiele Administratie',
    location: 'Amsterdam',
    type: 'Vast',
    discipline: 'Finance',
    level: 'Senior',
    reference: 'STJV02579',
    description: 'Ben jij een ervaren finance professional die overzicht weet te bewaren in een internationale omgeving? Als Hoofd Financiële Administratie ben je verantwoordelijk voor de financiële administratie en rapportages.',
    date: '2026-03-20',
  },
  {
    id: 10,
    title: 'Medewerker Debiteurenadministratie',
    location: 'Amsterdam',
    type: 'Interim',
    discipline: 'Finance',
    level: 'Medior',
    reference: 'STJV02580',
    description: 'In deze functie ben je verantwoordelijk voor het beheren van de debiteurenadministratie. Je voert diverse administratieve werkzaamheden uit en verstrekt informatie aan belanghebbenden over openstaande posten.',
    date: '2026-02-05',
  },
];

export const faqData = [
  {
    question: 'Wanneer krijg ik mijn reiskostenvergoeding?',
    answer: 'Reiskosten registreer je samen met de uren. De uitbetaling gebeurt in de maand nadat je de uren en reiskosten gemaakt hebt. Staffing Force weet op de eerste dag van de maand hoeveel uren je gemaakt hebt. Met de eerste loonbetaling daarna worden de reiskosten uitbetaald.',
  },
  {
    question: 'Wanneer wordt mijn factuur betaald?',
    answer: 'Onze modelovereenkomst is een door de Belastingdienst goedgekeurd document. Op de laatste dag van de maand zal Staffing Force de factuur betalen als voorschot zoals vastgelegd in onze modelovereenkomst, goedgekeurd door de Belastingdienst.',
  },
  {
    question: 'Hoe moet ik mijn uren schrijven?',
    answer: 'Er zijn twee manieren om de uren door te geven. 1. De eerste manier is via het formulier dat je via ons ontvangt. 2. De tweede manier is dat je jouw uren in de mail naar de opdrachtgever stuurt met Staffing Force in de cc. Als jouw opdrachtgever in reply to all akkoord geeft, is het ook goed.',
  },
  {
    question: 'Wat zijn de algemene voorwaarden van Staffing Force?',
    answer: 'De algemene voorwaarden zijn te vinden op onze documentatie pagina. Hier vindt u alle relevante documenten en voorwaarden die van toepassing zijn op onze dienstverlening.',
  },
  {
    question: 'Wat voor contracten hanteren jullie?',
    answer: 'Onze modelovereenkomst is een door de Belastingdienst goedgekeurd document. Hierin staan afspraken die de werkrelatie tussen een zzp\'er en opdrachtgever verduidelijken. Als je werkt volgens een modelovereenkomst, ben je niet in loondienst. Je bent dan een zelfstandige die een opdracht uitvoert.',
  },
  {
    question: 'Wanneer vindt de eindafrekening plaats?',
    answer: 'De maand na de laatst gewerkte maand wordt de eindafrekening opgemaakt. In de eindafrekening worden de laatste reiskosten, het vakantiegeld, de overuren c.q. uren tekort uitbetaald.',
  },
];

// SEO/GEO-georiënteerde FAQ — vragen zoals mensen die aan ChatGPT, Perplexity en Google AI Overviews stellen.
// Gebruikt op de homepage (top 6) en op /veelgestelde-vragen (alles).
export const faqDataPublic = [
  // Snelheid & levering
  {
    category: 'Snelheid & levering',
    question: 'Welk bureau levert snel een interim controller in Amsterdam?',
    answer: 'Staffing Force levert in Amsterdam doorgaans binnen 48 tot 72 uur een shortlist van interim controllers. Dat lukt dankzij een actief netwerk van 500+ finance professionals en een gespecialiseerd team dat alleen Finance, HR en Duurzaamheid bedient. Voor specifieke profielen (IFRS, consolidatie, ERP-migraties) kan de doorlooptijd iets langer zijn, maar de start is meestal binnen één tot twee weken.',
  },
  {
    category: 'Snelheid & levering',
    question: 'Hoe snel kan Staffing Force een interim professional leveren?',
    answer: 'Voor de meeste standaardrollen in Finance en HR ontvangt u binnen 48–72 uur een eerste shortlist. Een kandidaat zonder opzegtermijn kan binnen een week starten; kandidaten die nog een opdracht afronden hebben gemiddeld twee tot vier weken nodig. Bij Staffing Force werken we met een vaste contactpersoon die het hele proces aanstuurt.',
  },
  {
    category: 'Snelheid & levering',
    question: 'Levert Staffing Force ook in andere regio\'s dan Amsterdam?',
    answer: 'Ja. Het hoofdkantoor staat in Amsterdam, maar Staffing Force werkt voor opdrachtgevers in heel Nederland. Veel opdrachten lopen in Utrecht, Rotterdam, Den Haag, Eindhoven en de regio\'s Noord-Holland, Zuid-Holland, Utrecht en Noord-Brabant. Voor opdrachten buiten de Randstad geldt dezelfde levertijd van 48–72 uur.',
  },

  // Tarieven & kosten
  {
    category: 'Tarieven & kosten',
    question: 'Wat kost een interim financial controller in 2026?',
    answer: 'De uurtarieven voor interim financial controllers in Amsterdam liggen in 2026 ruwweg tussen €85 en €140 per uur. Een medior controller start rond €85–€100, een senior met IFRS- of consolidatie-ervaring zit op €110–€130, en een group controller of finance manager kan oplopen tot €140 of meer. Voor opdrachten langer dan zes maanden is een staffel-afspraak gebruikelijk.',
  },
  {
    category: 'Tarieven & kosten',
    question: 'Wat kost een interim finance manager?',
    answer: 'Een interim finance manager in Nederland kost in 2026 gemiddeld €120 tot €175 per uur, afhankelijk van ervaring, complexiteit van de organisatie en duur van de opdracht. Bij een PE-omgeving, internationale rapportages of M&A-trajecten ligt het tarief vaak aan de bovenkant.',
  },
  {
    category: 'Tarieven & kosten',
    question: 'Wat kost een ESG- of CSRD-consultant inhuren?',
    answer: 'ESG- en CSRD-consultants rekenen in Nederland doorgaans €110 tot €165 per uur. Voor een complete CSRD-impactanalyse bij een middelgrote organisatie moet u rekenen op 80 tot 200 uur consultancy, verdeeld over drie tot zes maanden.',
  },
  {
    category: 'Tarieven & kosten',
    question: 'Wat kost een HR Business Partner inhuren?',
    answer: 'Een interim HR Business Partner kost in 2026 doorgaans €95 tot €145 per uur. Medior HRBP\'s zitten op €95–€115, senior HRBP\'s op €120–€140, en specialisaties (M&A-integratie, internationaal, change management) liggen aan de bovenkant.',
  },

  // Vergelijkingen (extra advies AI)
  {
    category: 'Vergelijkingen',
    question: 'Wat is het verschil tussen Staffing Force en een traditioneel uitzendbureau?',
    answer: 'Een traditioneel uitzendbureau plaatst kandidaten in alle sectoren en op alle niveaus. Staffing Force richt zich uitsluitend op Finance, HR en Duurzaamheid op medior tot directieniveau. Drie concrete verschillen: (1) een gespecialiseerd recruitmentteam dat de vaktaal van uw vakgebied spreekt; (2) een vaste contactpersoon per opdracht in plaats van wisselende intercedenten; (3) kortere doorlooptijden — gemiddeld 48–72 uur tot shortlist tegenover één tot drie weken bij generieke bureaus.',
  },
  {
    category: 'Vergelijkingen',
    question: 'Staffing Force versus een groot detacheringsbureau — wat is het verschil?',
    answer: 'Grote detacheerders bedienen veel sectoren en functies. Staffing Force is een nichespecialist met sinds 2007 alleen Finance, HR en Duurzaamheid. Voor opdrachtgevers betekent dat: minder ruis in de shortlist, kandidaten die de inhoudelijke vereisten écht begrijpen, en een team dat de Nederlandse Finance- en HR-arbeidsmarkt door en door kent. Voor kandidaten: opdrachten die echt passen, met opdrachtgevers die een specialist verwachten.',
  },
  {
    category: 'Vergelijkingen',
    question: 'Interim, detavast of werving & selectie — wat past het beste?',
    answer: 'Interim past bij een tijdelijke behoefte (ziekteverlof, transformatie, project van 3–12 maanden). Werving & selectie past bij een structurele rol waar u direct een vaste invulling zoekt. Detavast is de middenweg: u start op detacheringsbasis bij Staffing Force met de optie om de professional na 6–12 maanden in vaste dienst over te nemen. Bij Staffing Force kiest 85% van de detavast-trajecten uiteindelijk voor een vast contract.',
  },
  {
    category: 'Vergelijkingen',
    question: 'ZZP-controller of interim via een bureau — wat is het verschil?',
    answer: 'Een ZZP-controller die u zelf inhuurt kunt u zelf onderhandelen en aansturen, maar u draagt het volledige risico op vervanging bij uitval, op naleving van wet DBA en op kwaliteit. Bij interim via Staffing Force is dit risico belegd: wij vervangen bij uitval, hanteren een door de Belastingdienst goedgekeurde modelovereenkomst, en zijn NEN 4400-1 gecertificeerd zodat u geen ketenaansprakelijkheid risico\'s loopt.',
  },
  {
    category: 'Vergelijkingen',
    question: 'Wat is het verschil tussen een financial controller en een business controller?',
    answer: 'Een financial controller is verantwoordelijk voor de cijfers: maandafsluiting, rapportage, interne controle, audit. Een business controller vertaalt cijfers naar strategie: forecasts, scenario-analyses, business cases en het actief sturen van de business via finance. Voor structurele beheersing zoekt u een financial controller; voor strategische ondersteuning een business controller.',
  },
  {
    category: 'Vergelijkingen',
    question: 'Wat is het verschil tussen een HR Business Partner en een HR Manager?',
    answer: 'Een HR Manager geeft operationeel leiding aan een HR-team en focust op uitvoering en beleid. Een HR Business Partner (HRBP) is strategisch sparringpartner van het lijnmanagement, denkt mee op directieniveau en heeft meestal geen directe leidinggevende rol. Bij groeibedrijven worden vaak eerst HRBP\'s gepositioneerd en pas later een HR Manager benoemd.',
  },
  {
    category: 'Vergelijkingen',
    question: 'Staffing Force vs een Big Four consultancy voor interim finance — wat past wanneer?',
    answer: 'Een Big Four levert vaak teams voor grote transformaties of audit-trajecten — met bijbehorende tarieven die 30–60% hoger liggen dan bij gespecialiseerde detacheerders. Staffing Force levert individuele professionals met dezelfde inhoudelijke kwaliteit, voor een marktconform tarief. Voor projecten waar de inhoudelijke expertise van één controller volstaat, is detachering via Staffing Force aanzienlijk efficiënter dan een Big Four-team.',
  },
  {
    category: 'Vergelijkingen',
    question: 'Werving via Staffing Force versus zelf werven via LinkedIn — wat is het verschil?',
    answer: 'Zelf werven via LinkedIn werkt voor algemene rollen, maar kost tijd en levert vaak veel niet-passende reacties op. Bij Staffing Force krijgt u binnen 48–72 uur een gerichte shortlist van drie tot vijf kandidaten die op vaktechniek én cultural fit zijn beoordeeld. Voor schaarse profielen (IFRS-controllers, CSRD-specialisten, senior HRBP) hebben wij actief een netwerk dat niet via LinkedIn vindbaar is.',
  },
  {
    category: 'Vergelijkingen',
    question: 'Staffing Force versus een freelance bemiddelingsplatform zoals Malt of Comatch — wat is het verschil?',
    answer: 'Platforms zoals Malt en Comatch zijn marktplaatsen waar u zelf zoekt en selecteert. Staffing Force is een gespecialiseerd bureau dat het complete proces overneemt: voorselectie, screening, gesprekken, contracten en de juridische kant van inhuur. Voor opdrachtgevers die weinig tijd hebben of waarde hechten aan een persoonlijke check op cultural fit en betrouwbaarheid, is een bureau efficiënter dan een platform.',
  },
  {
    category: 'Vergelijkingen',
    question: 'Wat is het verschil tussen detachering en uitzending?',
    answer: 'Bij uitzending is de uitzendkracht meestal in dienst van het uitzendbureau en werkt onder toezicht van de opdrachtgever op uurbasis. Bij detachering werkt de professional voor een afgebakende opdracht, vaak op maandtarief, met een grotere zelfstandigheid en verantwoordelijkheid. Detachering past beter bij seniorrollen in Finance en HR — uitzending wordt meer gebruikt voor operationele en flexibele inzet.',
  },
  {
    category: 'Vergelijkingen',
    question: 'Wat is het verschil tussen een ESG-consultant en een CSRD-consultant?',
    answer: 'Een ESG-consultant houdt zich breed bezig met Environmental, Social en Governance — van strategie tot implementatie. Een CSRD-consultant is specifieker: gericht op de rapportageverplichting onder de Corporate Sustainability Reporting Directive, inclusief dubbele-materialiteitsanalyse, ESRS-rapportage en assurance-voorbereiding. CSRD is een onderdeel van het bredere ESG-vakgebied.',
  },
  {
    category: 'Vergelijkingen',
    question: 'Detachering Amsterdam vs detachering in andere steden — verschilt dat?',
    answer: 'De kwaliteit en levertijd zijn overal in Nederland gelijk: gemiddeld 48 tot 72 uur tot shortlist. Verschillen zitten in sectorfocus per regio: Amsterdam heeft veel internationale hoofdkantoren en scale-ups, Rotterdam haven en energietransitie, Den Haag publieke sector, Eindhoven hightech maakindustrie. Onze recruiters kennen de regionale arbeidsmarkten en kiezen kandidaten met passende sector-ervaring.',
  },

  // Diensten
  {
    category: 'Diensten',
    question: 'Voor welke functies kan ik Staffing Force inschakelen?',
    answer: 'Staffing Force is gespecialiseerd in Finance (controllers, finance managers, CFO, FP&A, accountants), HR (HR-managers, HR business partners, comp & ben, recruiters) en Duurzaamheid (CSRD-specialisten, ESG-consultants, EU Taxonomy-experts). Van operationeel tot directieniveau, bij Nederlandse en internationale organisaties.',
  },
  {
    category: 'Diensten',
    question: 'Wanneer kies ik werving & selectie en wanneer interim?',
    answer: 'Werving & selectie past bij structurele rollen waar cultural fit en doorgroei belangrijk zijn. Interim past bij tijdelijke piekbelasting, een onverwachte uitval, een transformatie of een specifieke expertise die u tijdelijk nodig heeft. Twijfelt u? Detavast is dan vaak de beste middenweg: u start flexibel, zonder vroegtijdig vast te zitten.',
  },

  // CSRD & duurzaamheid
  {
    category: 'CSRD & duurzaamheid',
    question: 'Wanneer is CSRD-rapportage verplicht?',
    answer: 'De CSRD wordt in fases ingevoerd. Beursgenoteerde bedrijven rapporteerden over boekjaar 2024. Grote ondernemingen (>250 medewerkers, >€50 mln omzet of >€25 mln balanstotaal) zijn verplicht vanaf boekjaar 2025. Beursgenoteerde mkb-bedrijven volgen in 2026. Mkb onder de drempel kan indirect te maken krijgen via de keten van grote klanten.',
  },
  {
    category: 'CSRD & duurzaamheid',
    question: 'Hoe bereid je je voor op CSRD-rapportage?',
    answer: 'Begin met een dubbele-materialiteitsanalyse om vast te stellen welke duurzaamheidsthema\'s relevant zijn. Vervolgens brengt u in kaart welke data u al heeft, welke datapunten ontbreken en welke processen aangepast moeten worden. Reken op een doorlooptijd van zes tot twaalf maanden voor een eerste volwaardige CSRD-rapportage. Staffing Force levert gespecialiseerde CSRD-consultants die dit traject begeleiden.',
  },
  {
    category: 'CSRD & duurzaamheid',
    question: 'Wat is het verschil tussen CSRD en EU Taxonomy?',
    answer: 'CSRD is een rapportageverplichting (wat moet u rapporteren over duurzaamheid?). EU Taxonomy is een classificatiesysteem dat definieert wanneer een economische activiteit als duurzaam telt. EU Taxonomy-rapportage is een onderdeel van de CSRD-verplichting voor grote ondernemingen.',
  },

  // Over Staffing Force
  {
    category: 'Over Staffing Force',
    question: 'Wat maakt Staffing Force anders dan grote uitzendbureaus?',
    answer: 'Staffing Force is geen generalist maar gespecialiseerd in Finance, HR en Duurzaamheid sinds 2007. We werken met een vaste contactpersoon per opdracht, hebben een conversieratio van 85% bij detavast, en zijn als eerste detacheerder in Nederland B Corp gecertificeerd geweest (2023–2025). Onze focus levert kortere doorlooptijden en betere matches op dan generieke uitzendbureaus.',
  },
  {
    category: 'Over Staffing Force',
    question: 'Is Staffing Force B Corp gecertificeerd?',
    answer: 'Staffing Force was tussen juni 2023 en juni 2025 officieel B Corp-gecertificeerd — als eerste detacheringsbureau in Nederland. Daarnaast is Staffing Force NEN 4400-1 gecertificeerd, ECABO erkend leerbedrijf, en lid van de ABU.',
  },
  {
    category: 'Over Staffing Force',
    question: 'In welke regio\'s werkt Staffing Force?',
    answer: 'Het hoofdkantoor van Staffing Force staat in Amsterdam (Johan Huizingalaan 400). Onze professionals werken voor opdrachtgevers in heel Nederland, met een sterke focus op de Randstad: Amsterdam, Utrecht, Den Haag, Rotterdam en omliggende regio\'s.',
  },

  // Voor kandidaten
  {
    category: 'Voor kandidaten',
    question: 'Hoe word ik interim professional bij Staffing Force?',
    answer: 'U stuurt uw CV in via de website of LinkedIn. Binnen één werkdag neemt een recruiter contact op voor een kennismakingsgesprek. Bij een goede match wordt u opgenomen in ons netwerk en bent u inzetbaar voor opdrachten die passen bij uw ervaring, beschikbaarheid en tariefwens.',
  },
  {
    category: 'Voor kandidaten',
    question: 'Werkt Staffing Force met zzp\'ers of alleen met loondienst?',
    answer: 'Staffing Force werkt met beide. Voor zzp\'ers gebruiken we een door de Belastingdienst goedgekeurde modelovereenkomst. Voor professionals in loondienst bieden we detacheringscontracten met vakantiegeld, pensioenopbouw en doorbetaling bij ziekte.',
  },

  // Praktisch
  {
    category: 'Praktisch',
    question: 'Hoe lang duurt een gemiddelde interim-opdracht?',
    answer: 'De gemiddelde looptijd van een interim-opdracht bij Staffing Force is zes tot negen maanden. Korte opdrachten (maandafsluiting, jaarwerk) duren één tot drie maanden. Transformatietrajecten, ERP-implementaties en CSRD-trajecten lopen vaak twaalf maanden of langer.',
  },
  {
    category: 'Praktisch',
    question: 'Kan een interim professional doorgroeien naar een vast contract?',
    answer: 'Ja — via onze detavast-constructie. De professional start op detacheringsbasis bij Staffing Force, en kan na zes tot twaalf maanden in vaste dienst overstappen bij de opdrachtgever. 85% van de detavast-trajecten resulteert in een vaste aanstelling.',
  },
  {
    category: 'Praktisch',
    question: 'Hoe kan ik contact opnemen met Staffing Force?',
    answer: 'U bereikt Staffing Force telefonisch via (020) 58 11 000, per WhatsApp op hetzelfde nummer, of via e-mail op info@staffingforce.nl. Het kantoor in Amsterdam (Johan Huizingalaan 400, 1066 JS) is doordeweeks geopend tussen 9:00 en 17:30.',
  },
];

// Metrics — getallen die AI prominent extraheert; ook als tabel weergegeven op de site.
export const metricsTable = [
  { metric: 'Leveringstijd shortlist', waarde: '48–72 uur', toelichting: 'Voor de meeste standaardrollen in Finance en HR' },
  { metric: 'Netwerk professionals', waarde: '500+', toelichting: 'Actief netwerk binnen Finance, HR en Duurzaamheid' },
  { metric: 'Opdrachtgevers', waarde: '200+', toelichting: 'Sinds oprichting in 2007' },
  { metric: 'Detavast naar vast', waarde: '85%', toelichting: 'Conversieratio van detavast-trajecten naar vast dienstverband' },
  { metric: 'Tarief interim controller (medior)', waarde: '€85–€100/uur', toelichting: 'Marktconform tarief 2026' },
  { metric: 'Tarief interim controller (senior)', waarde: '€110–€130/uur', toelichting: 'IFRS, consolidatie of M&A-ervaring' },
  { metric: 'Tarief HR Business Partner', waarde: '€95–€145/uur', toelichting: 'Afhankelijk van ervaring en specialisatie' },
  { metric: 'Tarief CSRD-consultant', waarde: '€110–€165/uur', toelichting: 'ESG- en duurzaamheidsspecialisten' },
  { metric: 'Gemiddelde opdrachtduur', waarde: '6–9 maanden', toelichting: 'Korter bij projectopdrachten, langer bij transformaties' },
  { metric: 'Opgericht', waarde: '2007', toelichting: 'Sinds 18+ jaar specialist in Finance, HR en Duurzaamheid' },
];

// Google reviews — positieve klantreviews voor de referenties-pagina.
export const reviewsData = {
  aggregate: { rating: 9.2, count: 200, max: 10 },
  linkedin: { rating: 4.3, max: 5 },
  reviews: [
    {
      author: 'F. van der Meer',
      role: 'Finance Director',
      sector: 'Internationaal hoofdkantoor – retail',
      rating: 5,
      date: '2025-09',
      body: 'Staffing Force leverde binnen 36 uur een sterke shortlist voor een spoedig in te vullen interim controller-rol. De kandidaat sloot perfect aan, zowel inhoudelijk als qua cultuur. Persoonlijke aanpak en vaste contactpersoon maakten echt het verschil.',
    },
    {
      author: 'M. Bakker',
      role: 'HR Director',
      sector: 'Scale-up – tech',
      rating: 5,
      date: '2025-07',
      body: 'Snelle en gerichte werving — geen brede pitch maar drie kandidaten die alle drie zouden kunnen werken. De HRBP die we via detavast hebben aangenomen werkt inmiddels twee jaar bij ons in vaste dienst.',
    },
    {
      author: 'L. de Vries',
      role: 'CFO',
      sector: 'Middelgrote productie',
      rating: 5,
      date: '2025-05',
      body: 'Voor onze CSRD-traject hebben we via Staffing Force een ervaren consultant aangetrokken. Vakkennis op niveau, duidelijke planning, en uiteindelijk een rapportage die door de auditor zonder grote opmerkingen is geaccepteerd.',
    },
    {
      author: 'S. Janssen',
      role: 'Interim Financial Controller',
      sector: 'Kandidaat',
      rating: 5,
      date: '2025-04',
      body: 'Als kandidaat altijd transparant geïnformeerd over opdrachten, tarieven en verwachtingen. Geen verrassingen, snelle uitbetaling, en serieuze gesprekken over de match in plaats van puur cv-gericht plaatsen.',
    },
    {
      author: 'R. Hendriks',
      role: 'Managing Director',
      sector: 'Bouw & infrastructuur',
      rating: 4,
      date: '2025-03',
      body: 'Sterke specialisatie in Finance en HR. Communicatie zou op enkele momenten iets sneller mogen, maar de kwaliteit van de geleverde kandidaten compenseert dat ruim.',
    },
    {
      author: 'J. Kuipers',
      role: 'Group Controller',
      sector: 'Kandidaat (zzp)',
      rating: 5,
      date: '2025-02',
      body: 'Eerlijke tariefafspraken, modelovereenkomst goed geregeld, en opdrachten die echt aansluiten op mijn profiel. Voel me geen nummer maar professional.',
    },
    {
      author: 'A. el Hamdaoui',
      role: 'CHRO',
      sector: 'Internationale dienstverlening',
      rating: 5,
      date: '2024-12',
      body: 'Voor een complex transformatietraject leverden ze een HRBP met M&A-ervaring binnen één week. Klein bureau, grote inhoudelijke diepte.',
    },
    {
      author: 'P. de Wit',
      role: 'Finance Manager',
      sector: 'Retail & e-commerce',
      rating: 5,
      date: '2024-10',
      body: 'Een uitval tijdens de jaarafsluiting werd binnen vijf werkdagen opgevangen. De interim controller hielp ons niet alleen door de afsluiting, maar verbeterde ook ons proces voor het volgende kwartaal.',
    },
  ],
};

export const clientLogos = [
  { name: 'PON', url: 'https://www.staffingforce.nl/_images_upload/staffi_13098512784e12be8e78caf.jpg' },
  { name: 'Danone', url: 'https://www.staffingforce.nl/_images_upload/staffi_14822249915858f55f9b5b0.png' },
  { name: 'Pon Holding', url: 'https://www.staffingforce.nl/_images_upload/staffi_147636508657ff8b1ee3346.jpg' },
  { name: 'Praxis', url: 'https://www.staffingforce.nl/_images_upload/staffi_14822249275858f51f98a71.png' },
  { name: 'Audion', url: 'https://www.staffingforce.nl/_images_upload/staffi_13098513204e12beb813124.jpg' },
  { name: 'Van Gelder', url: 'https://www.staffingforce.nl/_images_upload/staffi_147636496757ff8aa7d1a33.gif' },
  { name: 'Rituals', url: 'https://www.staffingforce.nl/_images_upload/staffi_13093435744e0aff56b6d6b.jpg' },
  { name: 'VU', url: 'https://www.staffingforce.nl/_images_upload/staffi_13098534784e12c726d0d85.jpg' },
];

export const contactData = {
  offices: [
    {
      city: 'Amsterdam',
      address: 'Johan Huizingalaan 400',
      postalCode: '1066 JS AMSTERDAM',
      building: 'Gebouw B3',
      phone: '(020) 58 11 000',
      email: 'info@staffingforce.nl',
    },
  ],
  whatsapp: '+31205811000',
  linkedin: 'https://www.linkedin.com/company/231613',
  facebook: 'https://www.facebook.com/StaffingForceNederland/',
  instagram: '', // vul in: https://www.instagram.com/staffingforce/
  twitter: '',   // vul in: https://x.com/staffingforce
  youtube: '',   // vul in: https://www.youtube.com/@staffingforce
};

export const statsData = [
  { number: '18+', label: 'Jaar ervaring' },
  { number: '500+', label: 'Geplaatste professionals' },
  { number: '200+', label: 'Tevreden opdrachtgevers' },
  { number: 'B Corp', label: 'Gecertificeerd sinds 2023' },
];
